/**
 * 设计思路：
 * 1、level动态传入：默认5级
 * 2、areaCode动态传入：不传默认空
 * 3、根据areaCode获取不可选的区域的值；并且不可编辑
 * 3、必须选择上一级之后才能选择下一级;默认placehoder为已选择
 * 4、上一级改变时清空下面各级数据：（区域编码改变）
 * 5、选择完一级之后emit出去areaCode
 * 6、传入areaCode一传入的为准；不传入则从用户信息取；传入‘0’默认省可以选择
*/

import Service from './service';
import { mapGetters } from 'vuex';
export default {
  name: 'LocationSelect',
  data() {
    return {
      city_id: '',
      region: { // 各级的areaCode集合
        province: null,
        city: null,
        district: null,
        town: null,
        village: null
      },
      provinceList: [],
      cityList: [],
      districtList: [],
      townList: [],
      villageList: []
    };
  },
  props: {
    isShowProvince: {
      type: Boolean,
      default: true
    },
    currentAreaCode: {
      type: String,
      default: ''
    },
    level: {
      type: Number,
      default: 5
    },
    width: {
      type: Number,
      default: 0
    }
  },
  computed: {
    ...mapGetters(['getTenantParams'])
  },
  created() {
    // 如果展示省份 则查询省份
    // this.getCityList('34');
    this.isShowProvince ? this.getProvinceList() : this.getCityList(this.getTenantParams.areaCode);
  },
  mounted() {
    if (this.width !== 0) {
      document.querySelectorAll('.location .el-input').forEach(item => {
        item.style.width = this.width + 'px';
      });
      document.querySelectorAll('.location .el-input__inner').forEach(item => {
        item.style.width = this.width + 'px';
      });
      document.querySelectorAll('.location .el-col-4').forEach(item => {
        item.style.width = this.width + 20 + 'px';
      });
      document.querySelectorAll('.location .el-col-6').forEach(item => {
        item.style.width = this.width + 20 + 'px';
      });
    }
  },
  watch: {
    currentAreaCode (newQuestion, oldQuestion) {
      // console.log(newQuestion, 'newQuestion');
      this.splitAreaCode(newQuestion);
      if (oldQuestion !== newQuestion && newQuestion) {
        this.splitAreaCodeName();
      }
    }
  },
  methods: {
    /**
     * 清空
    */
    onReset() {
      this.cityList = [];
      this.districtList = [];
      this.townList = [];
      this.villageList = [];
      // this.getProvinceList();
      // this.getCityList('34');
      this.isShowProvince ? this.getProvinceList() : this.getCityList(this.getTenantParams.areaCode);
      this.splitAreaCodeName();
    },
    /**
     * 拆分各级areaCode
     */
    splitAreaCode(areaCode) {
      const length = areaCode && areaCode.length;
      if (!length) {
        return false;
      }
      // eslint-disable-next-line default-case
      switch (length) {
      case 2:
        this.region = {
          province: areaCode,
          city: null,
          district: null,
          town: null,
          village: null
        };
        break;
      case 4:
        this.region = {
          province: areaCode.slice(0, 2),
          city: areaCode,
          district: null,
          town: null,
          village: null
        };
        break;
      case 6:
        this.region = {
          province: areaCode.slice(0, 2),
          city: areaCode.slice(0, 4),
          district: areaCode,
          town: null,
          village: null
        };
        break;
      case 9:
        this.region = {
          province: areaCode.slice(0, 2),
          city: areaCode.slice(0, 4),
          district: areaCode.slice(0, 6),
          town: areaCode,
          village: null
        };
        break;
      case 12:
        this.region = {
          province: areaCode.slice(0, 2),
          city: areaCode.slice(0, 4),
          district: areaCode.slice(0, 6),
          town: areaCode.slice(0, 9),
          village: areaCode
        };
        break;
      }
    },

    // 根据传入的currentAreaCode获取各级
    splitAreaCodeName() {
      Object.keys(this.region).forEach(key => {
        if (this.region[key]) {
          // eslint-disable-next-line default-case
          switch (key) {
          case 'province':
            this.getCityList(this.region.province);
            break;
          case 'city':
            this.getDistrictList(this.region.city);
            break;
          case 'district':
            this.getTownList(this.region.district);
            break;
          case 'town':
            this.getVillageList(this.region.town);
            break;
          case 'village':
            this.selectVillageAction(this.region.village);
            break;
          }
        }
      });
    },

    /**
     * 1、上一级没有数据，下一集提示框显示：请选择上一级
     * 2、上一级有数据但是下一集没有数据提示：无数据
     */
    formateSelectDownValue(level) {
      const areaCodeArr = Object.values(this.region);
      if (areaCodeArr[level-1] && areaCodeArr[level-1].length) {
        document.querySelectorAll('.el-select-dropdown__empty').forEach((item) => {
          item.innerText = '暂无数据';
        });
      } else {
        document.querySelectorAll('.el-select-dropdown__empty').forEach((item) => {
          item.innerText = '请选择上一级';
        });
      }
    },

    /**
     * 获取地区列表
     */
    getProvinceList() {
      this.$emit('areaCodeChange', { areaCode: '' }); // emit出areacode
      this.provinceList = [];
      this.cityList = [];
      this.districtList = [];
      this.townList = [];
      this.villageList = [];
      Service.getAllProvinces().then(res => {
        if (res) this.provinceList = res.data;
        console.log(res, this.provinceList);
      });
    },

    /**
     * 获取地区列表
     */
    getCityList(event) {
      this.$emit('areaCodeChange', { areaCode: event, type: 'province' }); // emit出areacode
      this.cityList = [];
      this.districtList = [];
      this.townList = [];
      this.villageList = [];
      Service.getLocationList(event, 2).then(res => {
        if (res) {
          this.cityList = res.data;
        }
      });
    },

    /**
     * 获取地区列表
     */
    getDistrictList(event) {
      this.$emit('areaCodeChange', { areaCode: event, type: 'city' }); // emit出areacode
      this.districtList = [];
      this.townList = [];
      this.villageList = [];
      Service.getLocationList(event, 3).then(res => {
        if (res) {
          this.districtList = res.data;
        }
      });
    },

    /**
     * 获取地区列表
     */
    getTownList(event) {
      this.$emit('areaCodeChange', { areaCode: event, type: 'county' }); // emit出areacode
      this.townList = [];
      this.villageList = [];
      Service.getLocationList(event, 4).then(res => {
        if (res) {
          this.townList = res.data;
        }
      });
    },

    /**
     * 获取地区列表
     */
    getVillageList(event) {
      this.$emit('areaCodeChange', { areaCode: event, type: 'township' }); // emit出areacode
      this.villageList = [];
      Service.getLocationList(event, 5).then(res => {
        if (res) {
          this.villageList = res.data;
        }
      });
    },

    /**
     * 获取地区列表
     */
    selectVillageAction(event) {
      this.$emit('areaCodeChange', { areaCode: event, type: 'village' }); // emit出areacode
    }
  }
};
